import React from 'react'
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';

export default function InterfaceForm({ values, errorInputs, workFlowLists, isEdit, handleInputChange, t }) {
    console.log("workFlowLists", workFlowLists)

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                {t("interface.createEditInterface")}
            </Typography>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{xs:4, sm:4}}>
                    <FormControl fullWidth required size='small' disabled={isEdit}
                        error={Boolean(errorInputs.type_action?.isError)}
                    >
                        <InputLabel id="type_action">{t("interface.type")}</InputLabel>
                        <Select name='type_action' label={t("interface.type")}
                            value={values.type_action}
                            onChange={handleInputChange}
                        >
                            <MenuItem value="API">API</MenuItem>
                            <MenuItem value="BUTTON">BUTTON</MenuItem>
                            <MenuItem value="FLOW_PROCESS">FLOW_PROCESS</MenuItem>
                            <MenuItem value="MENU">MENU</MenuItem>
                            <MenuItem value="SUBMENU">SUBMENU</MenuItem>
                            <MenuItem value="CHART_REPORT">REPORTE GRAFICO</MenuItem>
                        </Select>
                        {errorInputs.type_action?.isError && <FormHelperText>{errorInputs.type_action.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <TextField fullWidth required size="small" name="name" label={t("interface.name")}
                        value={values.name}
                        onChange={handleInputChange}
                        error={!!errorInputs.name?.isError}
                        helperText={errorInputs.name?.messageError}
                    />
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <TextField fullWidth size="small" name="process_action" label={t("interface.processAction")}
                        value={values.process_action}
                        onChange={handleInputChange}
                        required={['MENU', 'SUBMENU'].includes(values.type_action)}
                        disabled={!['MENU', 'SUBMENU'].includes(values.type_action)}
                        error={!!errorInputs.process_action?.isError}
                        helperText={errorInputs.process_action?.messageError}
                    />
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <TextField fullWidth size="small" name="name_action" label={t("interface.nameAction")}
                        value={values.name_action}
                        onChange={handleInputChange}
                        required={['MENU', 'SUBMENU'].includes(values.type_action)}
                        disabled={!['MENU', 'SUBMENU'].includes(values.type_action)}
                        error={!!errorInputs.name_action?.isError}
                        helperText={errorInputs.name_action?.messageError}
                    />
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <TextField fullWidth size="small" name="path" label={t("interface.path")}
                        value={values.path}
                        onChange={handleInputChange}
                        required={['MENU', 'SUBMENU', 'CHART_REPORT'].includes(values.type_action)}
                        disabled={!['MENU', 'SUBMENU', 'CHART_REPORT'].includes(values.type_action)}
                        error={!!errorInputs.path?.isError}
                        helperText={errorInputs.path?.messageError}
                    />
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <TextField
                        fullWidth size="small" name="menu" label={t("interface.menuName")}
                        value={values.menu}
                        onChange={handleInputChange}
                        required={['MENU', 'SUBMENU', 'CHART_REPORT'].includes(values.type_action)}
                        disabled={!['MENU', 'SUBMENU', 'CHART_REPORT'].includes(values.type_action)}
                        error={!!errorInputs.menu?.isError}
                        helperText={errorInputs.menu?.messageError}
                    />
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <TextField fullWidth size="small" name="order_menu" label={t("interface.menuOrder")}
                        value={values.order_menu}
                        onChange={handleInputChange}
                        required={['MENU', 'SUBMENU', 'CHART_REPORT'].includes(values.type_action)}
                        disabled={!['MENU', 'SUBMENU', 'CHART_REPORT'].includes(values.type_action)}
                        error={!!errorInputs.order_menu?.isError}
                        helperText={errorInputs.order_menu?.messageError}
                    />
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <TextField fullWidth required size="small" name="icon" label={t("interface.icon")}
                        value={values.icon}
                        onChange={handleInputChange}
                        error={!!errorInputs.icon?.isError}
                        helperText={errorInputs.icon?.messageError}
                    />
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <TextField fullWidth required size="small" name="work_flow" label={t("interface.workflow")}
                        value={values.work_flow}
                        onChange={handleInputChange}
                        error={!!errorInputs.work_flow?.isError}
                        helperText={errorInputs.work_flow?.messageError}
                    />
                </Grid>

                <Grid size={{xs:4, sm:4}}>
                    <FormControl fullWidth required size='small'
                        error={Boolean(errorInputs.work_flow_related?.isError)}
                    >
                        <InputLabel id="work_flow_related">{t("interface.workflowRelated")}</InputLabel>
                        <Select
                            label={t("interface.workflowRelated")}
                            name='work_flow_related'
                            value={values.work_flow_related}
                            onChange={handleInputChange}
                        >
                            {workFlowLists.map((item, index) => <MenuItem value={item.value} key={`${item.value}-${index}`}>{item.key}</MenuItem>)}
                        </Select>
                        {errorInputs.work_flow_related?.isError && <FormHelperText>{errorInputs.work_flow_related.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>
            </Grid>
        </Box>
    )
}
